export default function isIe11() {
  // https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
  return typeof window !== 'undefined' && !!window.MSInputMethodContext && !!document.documentMode;
}